import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "cultureCycle";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    // 分页查询周期,
    cycleList: {
      list: [],
      total: 0
    }
  },
  actions: {
    //分页查询周期
    async getCycleList({ commit }, payload) {
      let result = await api.get(
        `/api/FishBatch?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setCycleList", result.data);
      }
      return result;
    },
    async addFishBatch(aa, payload) {
      // 添加周期
      let result = await api.post("/api/FishBatch", payload);
      return result;
    },
    //编辑---获取单行数据
    async getEditFishBatchData(a, payload) {
      let result = await api.get(`/api/FishBatch/` + payload);
      return result;
    },
    //获取已清塘当前行数据
    async getHasClearedData(a, payload) {
      let result = await api.get(`/api/FishBatch/GetView/` + payload);
      return result;
    },
    //编辑----保存
    async editFishBatchData(action, payload) {
      let result = await api.put("/api/FishBatch", payload);
      return result;
    },
    async getFishPondNoBatch({ commit }, payload) {
      // 获取基地下已清塘的鱼塘键值对列表/api/FishPond/NoBatch/{fishBaseId}
      let result = await api.get(`/api/FishPond/NoBatch/${payload}`);
      if (result.status === 200) {
        commit("setFishPondNoBatch", result.data);
      }
      return result;
    },
    //清塘
    async clearPond(action, payload) {
      let result = await api.put(`/api/FishBatch/ClearPond?id=${payload}`);
      return result;
    },
    //删除数据
    async delcultureList(action, payload) {
      let result = await api.delete(`/api/FishBatch/` + payload);
      return result;
    },
    //  清塘时获取最后一个批次进行比对
    async getLastBatchNo(action, payload) {
      let result = await api.get(`/api/FishBatch/GetLastBatchNo/${payload}`);
      return result;
    },
    // 获取养殖周期下拉框数据
    async getBatchList(aa, payload) {
      let result = await api.get("/api/FishBatch/GetBatchArray");
      return result.data;
    }
  },
  mutations: {
    setCycleList(state, payload) {
      state.cycleList = payload;
    }
  },
  getters: {}
});

export default moduleName;
